/**
 * Sistema de logging condicional para CentralGym
 * Solo muestra logs en modo desarrollo (VUE_APP_BUILD_MODE = 1)
 */

const isDevelopment = process.env.VUE_APP_BUILD_MODE === "1";

const logger = {
  /**
   * Log general (console.log)
   * @param {...any} args - Argumentos a loggear
   */
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Log de información (console.info)
   * @param {...any} args - Argumentos a loggear
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Log de advertencia (console.warn)
   * @param {...any} args - Argumentos a loggear
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Log de error (console.error)
   * NOTA: Los errores siempre se muestran, incluso en producción
   * @param {...any} args - Argumentos a loggear
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * Log de debug con prefijo
   * @param {string} prefix - Prefijo para el log
   * @param {...any} args - Argumentos a loggear
   */
  debug: (prefix, ...args) => {
    if (isDevelopment) {
      console.log(`[${prefix}]`, ...args);
    }
  },

  /**
   * Log de tabla (console.table)
   * @param {any} data - Datos a mostrar en tabla
   */
  table: (data) => {
    if (isDevelopment) {
      console.table(data);
    }
  },

  /**
   * Log de tiempo (console.time/timeEnd)
   * @param {string} label - Etiqueta del timer
   */
  time: (label) => {
    if (isDevelopment) {
      console.time(label);
    }
  },

  timeEnd: (label) => {
    if (isDevelopment) {
      console.timeEnd(label);
    }
  },

  /**
   * Log de grupo (console.group/groupEnd)
   * @param {string} label - Etiqueta del grupo
   */
  group: (label) => {
    if (isDevelopment) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  }
};

// Exportar como default y también las funciones individuales
export default logger;
export const { log, info, warn, error, debug, table, time, timeEnd, group, groupEnd } = logger;
